import { CountryCache, GenCountryKey } from '~/apps/smartsend/lib/cache/CountryCache';
import useCountries from '~/hooks/use-countries';
import useOnLoad from '~/routes/use-on-load';

const useCountryBackgroundTask = () => {
  const { getLocalisedCountries } = useCountries();
  useOnLoad(() => {
    const begin = async () => {
      const countries = await getLocalisedCountries();
      countries.forEach((c) => {
        CountryCache[GenCountryKey(c)] = c;
      });
      console.log('BGTASK: Country Cache populated');
    };
    begin();
  });
};
export default useCountryBackgroundTask;
